import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=bef67078&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Info.vue?vue&type=custom&index=0&blockType=styley"
if (typeof block0 === 'function') block0(component)

export default component.exports